import { fallbackURL } from "../../consts/FallbackURL";

export const checkAuth = () => {
    if (sessionStorage.getItem('hooliToken') && sessionStorage.getItem('sessionId')) {
        return {
            hooliToken: sessionStorage.getItem('hooliToken'),
            sessionId: sessionStorage.getItem('sessionId')
        }
    };

    if (window.location.search) {
        const data = window.location.search.split("&");
        if (data) {
            sessionStorage.setItem('sessionId', data[0].split("=")[1]);
            sessionStorage.setItem('hooliToken', data[1].split("=")[1]);

            return {
                hooliToken: sessionStorage.getItem('hooliToken'),
                sessionId: sessionStorage.getItem('sessionId')
            }
        }
    }

    return window.location.assign(fallbackURL);
};